import { type FC } from 'react';
import { ProductAttributeDisplayPropsT } from '../ProductAttribute/ProductAttribute';
import { Col, Row, Image } from 'react-bootstrap';
import AttributeImg from '../ProductAttribute/AttributeImg/AttributeImg';
import AttributeBrandName from '../ProductAttribute/AttributeBrandName/AttributeBrandName';
import FlavourName from '../ProductAttribute/FlavourName/FlavourName';
import AttributePrice from '../ProductAttribute/AttributePrice/AttributePrice';
import AttributeAvailability from '../ProductAttribute/AttributeAvailability/AttributeAvailability';
import QuantityOrNotify from '../../../../ProductAttribute/QuantityOrNotify/QuantityOrNotify';
import clsx from 'clsx';
import { useProductsFilter } from '../../../../../Context/ProductsFilterContext';
import OverflowedTextTooltip from '../../../../OverflowedTextTooltip/OverflowedTextTooltip';
import ClearanceDescription from '../../../../ClearanceDescription/ClearanceDescription';
import styles from './ProductAttributeMobile.module.scss?module';
import LoginButtonSpan from '../../../../LoginButtonSpan/LoginButtonSpan';
import QuickViewButton from '../ProductAttribute/components/QuickViewButton/QuickViewButton';
import DepositInfo from '../../../Abstracts/DepositInfo/DepositInfo';
import depositImage from '../../../../../../../public/images/pfand_img.webp';

const ProductAttributeMobile: FC<ProductAttributeDisplayPropsT> = ({
  user,
  isClearance,
  attribute,
  getAttributeImages,
  onShowQuickView,
  allowBackorder = false,
}) => {
  const { filters } = useProductsFilter();
  return (
    <>
      {filters.view === 'list' ? (
        <Row>
          <Col xs={4} sm={3}>
            <div className="pt-2 w-100">
              <AttributeImg
                img={attribute.image_white_public_url}
                name={attribute.name}
                onClick={() => getAttributeImages(attribute.id)}
                isNew={attribute.product_size?.is_new}
                imageOverlayUri={attribute.product_size?.image_overlay_uri}
                isDeposit={
                  attribute.product_size?.single_deposit_price > 0 &&
                  attribute.product_size?.deposit_units_count > 0
                }
              />
            </div>
          </Col>

          <Col className="d-none d-sm-flex" sm={1} />
          <Col xs={8}>
            <div className={clsx(!user && 'h-50')}>
              <div className={clsx(styles.Brand, 'pt-2 text-end')}>
                <AttributeBrandName attribute={attribute} view={filters.view} />
              </div>
              <div className={clsx(styles.ProductName, 'text-end')}>
                <FlavourName
                  view={filters.view}
                  isClearance={isClearance}
                  productSizeName={attribute.product_size.name}
                  combinedDescription1={attribute.combined_description_1}
                />
              </div>

              {attribute.product_size.single_deposit_price > 0 &&
              attribute.product_size.deposit_units_count > 0 ? (
                <div className={'d-lg-none text-end'}>
                  <Image
                    src={depositImage}
                    alt="deposit_image"
                    width={50}
                    height={50}
                  />
                  <DepositInfo
                    unitsCount={attribute.product_size.deposit_units_count}
                    price={attribute.product_size.single_deposit_price}
                  />
                </div>
              ) : null}

              <div className="pt-2 text-end">
                <AttributePrice attribute={attribute} />
              </div>
            </div>
            {!user ? (
              <div className="h-50 d-flex align-items-end justify-content-end">
                <LoginButtonSpan className={styles.LoginButtonSpan} />
              </div>
            ) : null}
          </Col>
        </Row>
      ) : null}

      {filters.view === 'table' ? (
        <div className={styles.TableRow}>
          <div className={styles.TopRow}>
            <div className={styles.Left}>
              <div className={styles.Brand}>
                <AttributeBrandName
                  view={filters.view}
                  attribute={attribute}
                  isNew={attribute.product_size?.is_new}
                />
              </div>
              <div className={styles.ProductName}>
                <OverflowedTextTooltip text={attribute.product_size.name} />
              </div>
              {isClearance ? (
                <ClearanceDescription>
                  <OverflowedTextTooltip
                    text={attribute.combined_description_1}
                  />
                </ClearanceDescription>
              ) : null}
            </div>

            <div className={styles.Right}>
              {!user ? (
                <LoginButtonSpan className={styles.LoginButtonSpan} />
              ) : null}
              <AttributePrice attribute={attribute} />
            </div>
          </div>
          <div className={clsx(styles.RowContainer)}>
            <div className={styles.MetaRow}>
              <div className={styles.Availability}>
                <AttributeAvailability
                  view={filters.view}
                  user={user}
                  attributeName={attribute.name}
                  attributeEta={attribute.eta}
                  hasStock={attribute.has_stock}
                  allowBackorder={allowBackorder}
                />
              </div>

              <div className={styles.Actions}>
                <QuickViewButton
                  onShowQuickView={() => onShowQuickView(attribute.id)}
                />
                {user?.id ? (
                  <div className={styles.Qty}>
                    <QuantityOrNotify
                      className={styles.QtyInput}
                      product_attribute={attribute}
                      price={attribute.product_size?.price ?? 0}
                      combined_price={attribute.product_size?.combined_price}
                      allowBackorder={allowBackorder}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {filters.view === 'list' ? (
        <>
          <div className={clsx(styles.RowContainer)}>
            <div className={styles.MetaRow}>
              <div className={styles.Availability}>
                <AttributeAvailability
                  view={filters.view}
                  user={user}
                  attributeName={attribute.name}
                  attributeEta={attribute.eta}
                  hasStock={attribute.has_stock}
                  allowBackorder={allowBackorder}
                />
              </div>

              <div className={styles.Actions}>
                <QuickViewButton
                  onShowQuickView={() => onShowQuickView(attribute.id)}
                />
                {user?.id ? (
                  <div className={styles.Qty}>
                    <QuantityOrNotify
                      className={styles.QtyInput}
                      product_attribute={attribute}
                      price={attribute.product_size?.price ?? 0}
                      combined_price={attribute.product_size?.combined_price}
                      allowBackorder={allowBackorder}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <Row className="pt-3" />
        </>
      ) : null}
    </>
  );
};

export default ProductAttributeMobile;
